import { Channel, ROOT, Topic } from "../../constants";
import { MessageBrokerUtils, PageContextUtils, UrlUtils } from "../../utils";
import React, { useCallback, useEffect, useMemo } from "react";
import { UISelectors, UserContextSelectors } from "../../redux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { Brand } from "../../configurations";
import { FormattedMessage } from "react-intl";
import { Item } from "../../components/Menu";
import { LocalizationMessages } from "../../localization/messages";
import { MenuActionCreators } from "../../redux/action-creators";
import { SelectableMenuItem } from "../../components/Menu";
import { useSurvey } from "../../components/Survey/useSurvey";

const getResources = (brandId, surveyType) => {
  let surveyResources = {
    surveyText:
      surveyType === "perfect-10"
        ? LocalizationMessages.perfect10
        : LocalizationMessages.survey,
    menuItemTag: LocalizationMessages.menuItemTag,
    surveyIcon: surveyType === "perfect-10" ? "perfect-10" : "up-for-8"
  };

  if (brandId === Brand.Sport_MG_DK) {
    surveyResources.surveyText = LocalizationMessages.surveyDKMRG;
  } else if (brandId === Brand.Sport_CA) {
    surveyResources.menuItemTag = LocalizationMessages.menuItemTag;
    surveyResources.surveyIcon = "perfect-10";
  }
  return surveyResources;
};

export const SurveyMenuItem = props => {
  const links = useSelector(UISelectors.links);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const brandId = useSelector(UserContextSelectors.brandId);
  const dispatch = useDispatch();
  const { isSurveyEnabled, isSurveyVisible, surveyType } = useSurvey();

  const { surveyText, menuItemTag, surveyIcon } = useMemo(
    () => getResources(brandId, surveyType),
    [brandId, surveyType]
  );

  const dataTestId = useMemo(() => {
    if (brandId === Brand.Sport_CA) {
      return "uc-survey-perfect-10";
    }
    return surveyType === "perfect-10"
      ? `uc-survey-perfect-10`
      : "uc-survey-up-for-8";
  }, [surveyType]);

  const surveyUrls = useMemo(() => {
    const { clientPage, oldClientPage } = PageContextUtils.getSurveyData();

    return (
      (isSurveyEnabled && [clientPage, oldClientPage].filter(link => !!link)) ||
      []
    );
  }, [isSurveyEnabled]);

  const item = useMemo(
    () =>
      new Item({
        URL: UrlUtils.getSEOUrl(links.survey),
        title: surveyText,
        iconKey: surveyIcon
      }),
    [links.survey, surveyText, surveyIcon]
  );

  const selectSurveyItem = useCallback(
    url => {
      const { pathname, hash } = url || {};
      if (
        surveyUrls?.some(surveyUrl => {
          const { pathname: surveyPathName, hash: surveyHash } = new URL(
            surveyUrl,
            window.location.origin
          );

          const pathWithoutLang = UrlUtils.getURLWithoutLang(pathname);

          return (
            (pathWithoutLang &&
              pathWithoutLang !== ROOT &&
              pathWithoutLang === surveyPathName) ||
            (hash && hash === surveyHash)
          );
        })
      ) {
        dispatch(MenuActionCreators.select(item));
      }
    },
    [dispatch, item, surveyUrls]
  );

  useEffect(() => {
    selectSurveyItem(window.location);
  }, [selectSurveyItem, isMobile]);

  useEffect(() => {
    let subscription = MessageBrokerUtils.subscribe({
      channel: Channel.ROUTER,
      topic: Topic.Navigate,
      callback: url => {
        selectSurveyItem(new URL(url, window.location.origin));
      }
    });

    return () => {
      subscription?.unsubscribe();
    };
  }, [selectSurveyItem]);

  const onClick = () => {
    if (isMobile) {
      dispatch(MenuActionCreators.hideHamburgerMenu());
    }
  };

  return (
    isSurveyVisible && (
      <SelectableMenuItem
        {...props}
        onClick={onClick}
        item={item}
        dataTestId={dataTestId}
        tag={
          <span className="tag">
            <FormattedMessage {...menuItemTag} />
          </span>
        }
      />
    )
  );
};
